var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"8"}},[_c('app-countdown',{attrs:{"dateNow":_vm.moment(),"nextDay":_vm.moment(_vm.fechaFinal)}})],1),_c('v-col',{attrs:{"cols":"12","sm":"8"}},[_c('p',[_vm._v(_vm._s(_vm.description))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }